

















































import { Component, Vue, Watch } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex"
import { Route } from "vue-router";

@Component({
})
export default class Remarks extends Vue {
    addZero(val: string) {
        if (Number(val) < 10) {
            return "0" + val
        } else {
            return val
        }
    }
    // 删除备注
    deleteRemark(id: number) {
        this.$confirm(`亲，是否确认删除这条备注？`, "温馨提示").then((action: any) => {
            if (action === "confirm") {
                Vue.axios
                    .post(
                        `accountbookremark/delete?accountBookRemarkId=${id}`, 123)
                    .then(res => {
                        this.$utils.getRemarks();
                    });
            }
        })
    }
    // 选择备注
    activeId: number = 0
    addList(id: number) {
        this.activeId = id
    }
    editRemark(val: AccountBookList.AccountRemark) {
        this.$emit("clickAdd", val)
    }
    addRemark() {
        this.$emit("clickAdd")
    }

}
